import React from "react";
import { render } from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "regenerator-runtime/runtime";

import App from "./App";

render(<App />, document.getElementById("root"));
